export default __webpack_public_path__ + "static/media/Corsairs-treasure-03.fd77f4e3.png";